import { Forward, KeyboardArrowDown } from '@project-lary/react-material-symbols';
import { IS_NATIVE } from 'gcs-common/constants/deviceConstants';
import { CHAT_ROUTES } from 'gcs-common/constants/routes';
import IconButton from 'gcs-common/design-system/ui/icon-button';
import { cn } from 'gcs-common/design-system/utils/tailwind-merge';
import { useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useOnClickOutside } from 'usehooks-ts';

interface ForwardingOption {
  type?: string | null;
  index?: number | null;
  className?: string | null;
}

const TicketMessageOptions = (props: ForwardingOption) => {
  const { type, index, className } = props;
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { routeTicketId, ticketId } = useParams();
  const id = routeTicketId ?? ticketId;

  const shareTicketMessagePart = () => {
    navigate(CHAT_ROUTES.TICKET_SHARE_MESSAGE(id || '', type || '', index || 0));
    setIsOpen(false);
  };

  const innerRef = useRef(null);

  useOnClickOutside(innerRef, () => setIsOpen(false));

  if (IS_NATIVE) {
    return (
      <div className="absolute right-0 z-50 mt-2 w-48 rounded-md border border-neutral-3 bg-white shadow-lg">
        <div
          onClick={shareTicketMessagePart}
          className="flex cursor-pointer items-center gap-3 px-4 py-2 hover:rounded-md hover:bg-neutral-2 "
        >
          <Forward className="size-5" />
          <span>Weiterleiten</span>
        </div>
      </div>
    );
  }
  return (
    <div className="relative" ref={innerRef}>
      <IconButton
        Icon={KeyboardArrowDown}
        size="base"
        iconSize="text-xl"
        onClick={() => setIsOpen(!isOpen)}
        className={cn(
          'absolute top-0 right-0 cursor-pointer rounded-lg bg-white p-0 text-neutral-9 shadow-lg hover:border-neutral-3 hover:bg-neutral-1 active:border-neutral-4 active:bg-neutral-2',
          className,
        )}
      />
      {isOpen && (
        <div className="absolute right-0 z-50 mt-2 w-48 rounded-md border border-neutral-3 bg-white shadow-lg">
          <div
            onClick={shareTicketMessagePart}
            className="flex cursor-pointer items-center gap-3 px-4 py-2 hover:rounded-md hover:bg-neutral-2"
          >
            <Forward className="size-5" />
            <span>Weiterleiten</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default TicketMessageOptions;
